<template>
  <div>
    <h1 class="mb-4">Current Workload Report</h1>

    <b-row role="alert">
      <b-col>
        <div class="sr-only hidden" v-if="isLoading">Loading, Please Wait...</div>
      </b-col>
    </b-row>
  
    <b-table hover small responsive show-empty class="sr-caption"
      aria-live="polite"
      :fields="fields"
      :items="records"
      :busy="isLoading"
      label-sort-asc=""
      label-sort-desc=""
      caption="Current Workload Report table.  To sort the data in this table by a specific column,
                    go to the appropriate column header cell and use enter to sort the data ascending.
                    Use enter again to sort descending.">
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>

      <template v-slot:empty="scope">
        <p>No pending applications found.</p>
      </template>

      <template #cell(averageAge)="data">
        {{ (Math.round((data.item.averageAge + Number.EPSILON) * 100) / 100).toFixed(2) }}
      </template>

      <div slot="table-busy" class="text-center text-danger my-2">
          <b-spinner class="align-middle" style="margin-right:5px; margin-top:12px;"
                     label="Loading, Please Wait" aria-label="Loading, Please Wait"></b-spinner>
          <strong>Loading, Please Wait...</strong>
      </div>        

    </b-table>
  </div>
</template>

<script>
import axios from 'axios'
import axiosRetry from 'axios-retry'

axiosRetry(axios, { retries: 3,
                    retryDelay: axiosRetry.exponentialDelay  });

export default {
  data: () => ({
    fields: [
      {key: 'licenseCategory', sortable: true, label: 'Category'},
      {key: 'licenseSubCategory', sortable: true, label: 'Subcategory'},
      {key: 'licenseType', sortable: true, label: 'License Type'},
      {key: 'applicationType', sortable: true, label: 'Application Type'},
      {key: 'status', sortable: true, label: 'Application Status'},
      {key: 'totalCount', sortable: true, label: 'Count'},
      {key: 'maxAge', sortable: true, label: 'Max Age (Days)'},
      {key: 'averageAge', sortable: true, label: 'Average Age (Days)'},
    ],
    isLoading: false,
    records: [],
  }),

  watch: {
    records() {
      this.isLoading = false
    },
  },

  created () {
    this.initialize()
    document.title = "Current Workload Report - Body Art"
  },

  methods: {
    fetchRecords() {
        this.isLoading = true;
        let fullUrl = `${process.env.VUE_APP_API_BASE_URL}/metric/current/workload`          
        axios.get(fullUrl)
          .then(response => {
              this.records = response.data;
              this.isLoading = false;
          })
    },

    initialize () {
      this.fetchRecords()
    },
  }
}
</script>